// extracted by mini-css-extract-plugin
module.exports = {"header":"MyCompany_header__1duzK"};